import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import classnames from 'classnames/bind';
import styles from './DraggableItem.css';
var cx = classnames.bind(styles);
export default function DraggableItem(_ref) {
  var Element = _ref.as,
      index = _ref.index,
      children = _ref.children,
      dragStyleClass = _ref.dragStyleClass;
  return React.createElement(Draggable, {
    draggableId: "draggable-".concat(index),
    index: index
  }, function (provided, snapshot) {
    return React.createElement(Element, _extends({}, provided.draggableProps, provided.dragHandleProps, {
      ref: provided.innerRef
    }, snapshot.isDragging && {
      className: cx(dragStyleClass || 'dragging')
    }), children);
  });
}
DraggableItem.propTypes = {
  as: PropTypes.string,
  index: PropTypes.number.isRequired,
  children: PropTypes.node,
  dragStyleClass: PropTypes.shape({})
};
DraggableItem.defaultProps = {
  as: 'div',
  children: undefined,
  dragStyleClass: undefined
};